export var UserType;
(function (UserType) {
    UserType["UNKNOWN"] = "UNKNOWN";
    UserType["USER"] = "USER";
    UserType["AGENT"] = "AGENT";
})(UserType || (UserType = {}));
export var TransferType;
(function (TransferType) {
    TransferType["UNKNOWN"] = "UNKNOWN";
    TransferType["TRANSFERRED"] = "TRANSFERRED";
    TransferType["ENDED"] = "ENDED";
})(TransferType || (TransferType = {}));
export var Editor;
(function (Editor) {
    Editor["UNKNOWN"] = "UNKNOWN";
    Editor["EDITOR_X"] = "EDITOR_X";
    Editor["EDITOR"] = "EDITOR";
    Editor["ADI"] = "ADI";
})(Editor || (Editor = {}));
export var UserPriorityClass;
(function (UserPriorityClass) {
    UserPriorityClass["UNKNOWN"] = "UNKNOWN";
    /** Users that “live in Wix” */
    UserPriorityClass["FIRST_CLASS"] = "FIRST_CLASS";
    /** Top users, entry level/potential partners */
    UserPriorityClass["BUSINESS"] = "BUSINESS";
    UserPriorityClass["ECONOMY_PLUS"] = "ECONOMY_PLUS";
    /** Regular users */
    UserPriorityClass["NOT_PRIORITY"] = "NOT_PRIORITY";
})(UserPriorityClass || (UserPriorityClass = {}));
export var PartnerType;
(function (PartnerType) {
    PartnerType["UNKNOWN"] = "UNKNOWN";
    PartnerType["NOT_PARTNER"] = "NOT_PARTNER";
    PartnerType["HIGH_POTENTIAL"] = "HIGH_POTENTIAL";
    PartnerType["PARTNER_NOT_IN_PROGRAM"] = "PARTNER_NOT_IN_PROGRAM";
    PartnerType["PIONEER"] = "PIONEER";
    PartnerType["LEGEND"] = "LEGEND";
    PartnerType["CREATOR"] = "CREATOR";
    PartnerType["ICON"] = "ICON";
    PartnerType["EXPLORER"] = "EXPLORER";
})(PartnerType || (PartnerType = {}));
export var VerticalsTopVertical;
(function (VerticalsTopVertical) {
    VerticalsTopVertical["UNKNOWN"] = "UNKNOWN";
    VerticalsTopVertical["RESTAURANTS"] = "RESTAURANTS";
    VerticalsTopVertical["STORES"] = "STORES";
    VerticalsTopVertical["FITNESS"] = "FITNESS";
    VerticalsTopVertical["BOOKINGS"] = "BOOKINGS";
    VerticalsTopVertical["EVENTS"] = "EVENTS";
})(VerticalsTopVertical || (VerticalsTopVertical = {}));
export var Platform;
(function (Platform) {
    Platform["UNKNOWN"] = "UNKNOWN";
    Platform["DESKTOP"] = "DESKTOP";
    Platform["MOBILE"] = "MOBILE";
    Platform["APP"] = "APP";
})(Platform || (Platform = {}));
export var UserExperience;
(function (UserExperience) {
    UserExperience["User"] = "User";
    UserExperience["Partner"] = "Partner";
    UserExperience["Vista"] = "Vista";
    UserExperience["Dayful"] = "Dayful";
    UserExperience["Headless"] = "Headless";
    UserExperience["StudioClient"] = "StudioClient";
    UserExperience["StudioOwner"] = "StudioOwner";
    UserExperience["StudioMember"] = "StudioMember";
    UserExperience["Enterprise"] = "Enterprise";
    UserExperience["Developer"] = "Developer";
})(UserExperience || (UserExperience = {}));
export var SuggestionStateTrigger;
(function (SuggestionStateTrigger) {
    SuggestionStateTrigger["NONE"] = "NONE";
    SuggestionStateTrigger["EXPRESSED_INTEREST"] = "EXPRESSED_INTEREST";
    SuggestionStateTrigger["SNOOZED"] = "SNOOZED";
    SuggestionStateTrigger["REJECTED"] = "REJECTED";
    SuggestionStateTrigger["VIEW_FREQUENCY_CAP"] = "VIEW_FREQUENCY_CAP";
    SuggestionStateTrigger["UNKNOWN"] = "UNKNOWN";
    SuggestionStateTrigger["MARKED_IMPLEMENTED_BY_USER"] = "MARKED_IMPLEMENTED_BY_USER";
})(SuggestionStateTrigger || (SuggestionStateTrigger = {}));
export var ChatActionType;
(function (ChatActionType) {
    ChatActionType["UNKNOWN"] = "UNKNOWN";
    ChatActionType["ARTICLE"] = "ARTICLE";
    ChatActionType["AI_ARTICLE_ANSWER"] = "AI_ARTICLE_ANSWER";
    ChatActionType["BOT_MESSAGE"] = "BOT_MESSAGE";
    ChatActionType["TITLE_BOT_MESSAGE"] = "TITLE_BOT_MESSAGE";
    ChatActionType["USER_MESSAGE"] = "USER_MESSAGE";
    ChatActionType["VIDEO"] = "VIDEO";
    ChatActionType["IMAGE"] = "IMAGE";
    ChatActionType["BUTTONS"] = "BUTTONS";
    ChatActionType["VERTICAL_BUTTONS"] = "VERTICAL_BUTTONS";
    ChatActionType["CATEGORY_BUTTONS"] = "CATEGORY_BUTTONS";
    ChatActionType["COLLAPSIBLE_MESSAGE"] = "COLLAPSIBLE_MESSAGE";
    /** selectors */
    ChatActionType["PHONE"] = "PHONE";
    ChatActionType["SITE_SELECTOR"] = "SITE_SELECTOR";
    ChatActionType["DOMAIN_SELECTOR"] = "DOMAIN_SELECTOR";
    ChatActionType["PLAN_SELECTOR"] = "PLAN_SELECTOR";
    ChatActionType["ARTICLE_SELECTOR"] = "ARTICLE_SELECTOR";
    ChatActionType["INVOICE_SELECTOR"] = "INVOICE_SELECTOR";
    ChatActionType["SUGGESTION_SELECTOR"] = "SUGGESTION_SELECTOR";
    ChatActionType["TICKET_SELECTOR"] = "TICKET_SELECTOR";
    ChatActionType["CHANGE_MODE"] = "CHANGE_MODE";
    ChatActionType["LOGIN_SELECTOR"] = "LOGIN_SELECTOR";
    ChatActionType["TIMESLOT_SELECTOR"] = "TIMESLOT_SELECTOR";
    ChatActionType["SCHEDULED_CALLBACKS_LIST_SELECTOR"] = "SCHEDULED_CALLBACKS_LIST_SELECTOR";
    ChatActionType["SUCCESS_SUGGESTIONS_SELECTOR"] = "SUCCESS_SUGGESTIONS_SELECTOR";
    ChatActionType["USER_ACCOUNTS_SELECTOR"] = "USER_ACCOUNTS_SELECTOR";
    ChatActionType["INTENT_SELECTOR"] = "INTENT_SELECTOR";
    /** internal */
    ChatActionType["RESTART"] = "RESTART";
    ChatActionType["REDIRECT"] = "REDIRECT";
    ChatActionType["START"] = "START";
    ChatActionType["DELETE_SESSION"] = "DELETE_SESSION";
    ChatActionType["COLLAPSE_WIDGET"] = "COLLAPSE_WIDGET";
    ChatActionType["CHANGE_START_OVER_NODE_ID"] = "CHANGE_START_OVER_NODE_ID";
    ChatActionType["CHANGE_RESTART_CHAT_PARAMETERS"] = "CHANGE_RESTART_CHAT_PARAMETERS";
    /** live-chat */
    ChatActionType["AGENT_REPLIED"] = "AGENT_REPLIED";
    ChatActionType["AGENT_JOINED"] = "AGENT_JOINED";
    ChatActionType["AGENT_LEFT"] = "AGENT_LEFT";
    ChatActionType["CHAT_TRANSFERRED"] = "CHAT_TRANSFERRED";
    ChatActionType["WAITING_FOR_AGENT"] = "WAITING_FOR_AGENT";
})(ChatActionType || (ChatActionType = {}));
export var MessageStatus;
(function (MessageStatus) {
    MessageStatus["READ"] = "READ";
    MessageStatus["UNREAD"] = "UNREAD";
})(MessageStatus || (MessageStatus = {}));
export var ButtonsStyle;
(function (ButtonsStyle) {
    ButtonsStyle["UNKNOWN_STYLE"] = "UNKNOWN_STYLE";
    ButtonsStyle["PRIMARY"] = "PRIMARY";
    ButtonsStyle["SECONDARY"] = "SECONDARY";
    ButtonsStyle["LINK"] = "LINK";
})(ButtonsStyle || (ButtonsStyle = {}));
export var ChatMode;
(function (ChatMode) {
    ChatMode["UNKNOWN"] = "UNKNOWN";
    ChatMode["CHATBOT"] = "CHATBOT";
    ChatMode["LIVE_CHAT"] = "LIVE_CHAT";
})(ChatMode || (ChatMode = {}));
export var AttachmentType;
(function (AttachmentType) {
    AttachmentType["IMAGE"] = "IMAGE";
    AttachmentType["VIDEO"] = "VIDEO";
})(AttachmentType || (AttachmentType = {}));
export var AttachingMethod;
(function (AttachingMethod) {
    AttachingMethod["BUTTON"] = "BUTTON";
    AttachingMethod["DROP"] = "DROP";
    AttachingMethod["PASTE"] = "PASTE";
})(AttachingMethod || (AttachingMethod = {}));
export var ChatbotUIAction;
(function (ChatbotUIAction) {
    ChatbotUIAction["BUTTON_CLICKED"] = "BUTTON_CLICKED";
    ChatbotUIAction["SELECTOR_CLICKED"] = "SELECTOR_CLICKED";
    ChatbotUIAction["CATEGORY_CLICKED"] = "CATEGORY_CLICKED";
    ChatbotUIAction["SEND_MESSAGE"] = "SEND_MESSAGE";
    ChatbotUIAction["MODAL_SITE_CLOSE"] = "MODAL_SITE_CLOSE";
    ChatbotUIAction["CLOSE_LIVE_CHAT"] = "CLOSE_LIVE_CHAT";
    ChatbotUIAction["CANT_LOGIN_CLICKED"] = "CANT_LOGIN_CLICKED";
    ChatbotUIAction["CHANGE"] = "CHANGE";
    /** user was navigated to new page by chatbot */
    ChatbotUIAction["NAVIGATED"] = "NAVIGATED";
    ChatbotUIAction["USER_ACTION_TIMEOUT"] = "USER_ACTION_TIMEOUT";
})(ChatbotUIAction || (ChatbotUIAction = {}));
export var SiteEditorType;
(function (SiteEditorType) {
    SiteEditorType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    SiteEditorType["EDITOR"] = "EDITOR";
    SiteEditorType["ADI"] = "ADI";
    SiteEditorType["EDITORX"] = "EDITORX";
    SiteEditorType["STUDIO"] = "STUDIO";
})(SiteEditorType || (SiteEditorType = {}));
export var SelectorType;
(function (SelectorType) {
    SelectorType["SITE_SELECTOR"] = "SITE_SELECTOR";
    SelectorType["DOMAIN_SELECTOR"] = "DOMAIN_SELECTOR";
    SelectorType["INVOICE_SELECTOR"] = "INVOICE_SELECTOR";
    SelectorType["PLAN_SELECTOR"] = "PLAN_SELECTOR";
    SelectorType["SUGGESTION_SELECTOR"] = "SUGGESTION_SELECTOR";
    SelectorType["ARTICLE_SELECTOR"] = "ARTICLE_SELECTOR";
    SelectorType["PHONE_SELECTOR"] = "PHONE_SELECTOR";
    SelectorType["TICKET_SELECTOR"] = "TICKET_SELECTOR";
    SelectorType["TIMESLOT_SELECTOR"] = "TIMESLOT_SELECTOR";
    SelectorType["SCHEDULED_CALLBACKS_LIST_SELECTOR"] = "SCHEDULED_CALLBACKS_LIST_SELECTOR";
    SelectorType["SUCCESS_SUGGESTIONS_SELECTOR"] = "SUCCESS_SUGGESTIONS_SELECTOR";
    SelectorType["USER_ACCOUNTS_SELECTOR"] = "USER_ACCOUNTS_SELECTOR";
    SelectorType["INTENT_SELECTOR"] = "INTENT_SELECTOR";
})(SelectorType || (SelectorType = {}));
export var Type;
(function (Type) {
    Type["CATEGORY"] = "CATEGORY";
})(Type || (Type = {}));
export var ActionName;
(function (ActionName) {
    ActionName["CLOSED"] = "CLOSED";
    ActionName["NOT_FOUND"] = "NOT_FOUND";
    ActionName["ROW_SELECTED"] = "ROW_SELECTED";
})(ActionName || (ActionName = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map